// THE MONEY SIDE OF TODAY — ONE LINE, AND DELIBERATELY NOT A LIST.
//
// What is owed is almost always non-empty, and a day page that opened every morning with
// fifteen invoices on it would teach you to scroll past the whole screen — the same
// reasoning that keeps open invoices out of the bell. So this is a count and a way in:
// מסך הכספים is where that question is actually answered, in the shape built for it.
//
// THE FIGURES ARE THE ONES ALREADY COUNTED. `alerts.money` comes from
// calculations/alerts.decorate — the same verdict on lateness the money screen and the
// dashboard render — so this strip cannot disagree with the screen it links to.
//
// IT DOES NOT ANSWER THE של מי FILTER, and says so on the line. The notification payload
// counts overdue invoices without splitting them by issuing partner; rather than appear
// to narrow with the filter above it and silently not, the strip names whose money it is
// showing. (Every other section on this page does narrow — each of their rows knows its
// own owner.)
// IT STAYS ON THE PAGE WHEN THERE IS NOTHING LATE, and says so. It used to remove itself,
// which made the one genuinely good piece of news — nothing is overdue — indistinguishable
// from a strip that failed to render. Clear is a state worth reporting: the line drops its
// red edge and its figure and simply says there is nothing in arrears.
import { Link } from 'react-router-dom';
import he from '../../i18n/he';
import { formatMoney } from '../../components/Money';

export default function MoneyStrip({ money }) {
  const overdue = money ? money.overdueCount : 0;

  return (
    <Link to="/money" className={`day-money${overdue === 0 ? ' is-clear' : ''}`}>
      <span className="day-money-main">
        {overdue === 0 ? (
          <span className="muted">{he.myDay.noMoneyOverdue}</span>
        ) : (
          <>
            <span className="badge red">{he.myDay.moneyOverdue(overdue)}</span>
            <span className="num">{formatMoney(money.overdueTotal)}</span>
            <span className="muted small-note">{he.myDay.moneyBoth}</span>
          </>
        )}
      </span>
      <span className="day-row-go">{he.myDay.goMoney}</span>
    </Link>
  );
}
